import { OnInit, Inject, Optional, OnDestroy, HostListener } from '@angular/core';
import { Component } from '@angular/core';
import { NXIRestServiceDefinition } from '../../services/NXI-Rest-service-definition';
import { ServiceRouter, IAuthorizationService } from '@pershing/pershing-core';
declare let dojoApp: any;
@Component({
    selector: 'change-default-group',
    templateUrl: './change-default-group.component.html'
})
export class ChangeDefaultGroupComponent implements OnInit, OnDestroy {
    appSettings: any;
    isAdvisor: boolean = false;
    serviceUrl: string = '';
    showDefaultAccount: boolean = true;

    @HostListener('document:accountsgroup.updated', ['$event']) onAcctGrpUpdated(e: any) {
        if (!!e.detail && !!e.detail.acctGrpUpdated && e.detail.acctGrpUpdated) {
            this.renderChangeDefaultGroup();
        }
    }

    constructor(private serviceRouter: ServiceRouter, private authService: IAuthorizationService, @Inject('AppSettings') @Optional() appSettings) {
        this.appSettings = appSettings;
        this.isAdvisor = appSettings ? appSettings.isAdvisor : false;
        this.showDefaultAccount = this.authService.isEntitled('DEFAULT_ACCOUNT');
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());

    }

    ngOnInit() {
        this.renderChangeDefaultGroup();
    }
    renderChangeDefaultGroup() {
        if (dojoApp) {
            dojoApp.renderChangeDefaultGroup({
                storeUrl: this.serviceUrl + '/portfolio/accounts',
                handleAs: 'json',
                sync: true,
                isAdvisor: this.isAdvisor,
                headers: {
                    'Content-Type': 'application/json'
                },
                preventCache: true,
                serviceUrl: this.serviceUrl
            });
        }
    }
    ngOnDestroy(): void {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyChangeDefaultGroup();
        }
    }
}
